import React from "react";
import { Link } from "react-router-dom";

export const FEATURE_PREVIEW_MODE = true;

const featureRules = {
  clientSubscriptions: {
    label: "The client subscriptions feature",
    entitlement: "can_use_subscriptions",
    preview: true,
    showPreviewNotice: true,
    upgradePath: "/admin/updates",
  },
  clientCardManagement: {
    label: "Client card management",
    entitlement: "can_use_subscriptions",
    preview: true,
    showPreviewNotice: true,
    upgradePath: "/admin/updates",
  },
  clientInvoiceEdit: {
    label: "Client invoice editing",
    entitlement: "can_use_invoice_edit",
    preview: true,
    showPreviewNotice: true,
    upgradePath: "/aadmin/updates",
  },
};

export const hasFeatureAccess = (farmDefaults, featureKey) => {
  const rule = featureRules[featureKey];
  if (!rule) return false;
  return (
    (FEATURE_PREVIEW_MODE && rule.preview) ||
    Boolean(farmDefaults?.[rule.entitlement])
  );
};

export const FeatureNotice = ({
  featureKey,
  farmDefaults,
  compact = false,
  prominent = false,
}) => {
  const rule = featureRules[featureKey];
  if (
    !rule ||
    !FEATURE_PREVIEW_MODE ||
    !rule.preview ||
    !rule.showPreviewNotice ||
    Boolean(farmDefaults?.[rule.entitlement])
  ) {
    return null;
  }

  return (
    <span
      style={
        prominent
          ? {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 10,
              width: "100%",
              boxSizing: "border-box",
              padding: 12,
              border: "1px solid #c3e3e9",
              borderLeft: "4px solid #0099BC",
              borderRadius: 4,
              background: "#edf7f8",
              color: "#31545b",
              fontSize: 13,
              lineHeight: 1.4,
            }
          : {
              display: "inline-flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 4,
              padding: compact ? "2px 0" : "4px 0",
              color: "#31545b",
              fontSize: compact ? 10 : 11,
              lineHeight: 1.3,
            }
      }
    >
      <span>
        {prominent
          ? `${rule.label} is available at no extra cost during preview.`
          : "Available at no extra cost during preview."}
      </span>
      {rule.upgradePath && (
        <Link
          to={rule.upgradePath}
          style={
            prominent
              ? {
                  display: "inline-flex",
                  alignItems: "center",
                  minHeight: 32,
                  padding: "0 12px",
                  borderRadius: 4,
                  background: "#ff7900",
                  color: "white",
                  fontWeight: 600,
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                }
              : { color: "inherit", fontWeight: 600 }
          }
        >
          More Info
        </Link>
      )}
    </span>
  );
};

export const FeatureAccess = ({ featureKey, farmDefaults, children }) => {
  const rule = featureRules[featureKey];
  if (!hasFeatureAccess(farmDefaults, featureKey)) {
    return (
      <div role="note" style={{ color: "#7a4b00", fontSize: 12 }}>
        {featureRules[featureKey]?.label || "This feature"} requires an eligible
        plan.
      </div>
    );
  }

  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      {children}
      <FeatureNotice
        featureKey={featureKey}
        farmDefaults={farmDefaults}
        compact
      />
    </div>
  );
};
